import {MouseEvent, ReactElement, useState} from "react";
import Button from "./Button";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";

export type DropdownButtonSubMenuItem = {
	name: string;
	href?: string;
	onClick?: (e: MouseEvent) => void;
};

interface DropdownButtonPropsInterface {
	border: boolean;
	transparent: boolean;
	text: string;
	href?: string;
	subMenuItems: DropdownButtonSubMenuItem[];
	customSubMenu?: JSX.Element;
	bgColor?: string;
	hoverBgColor?: string;
	minWidth?: string;
	textColor?: string;
	startAdornment?: ReactElement;
	hoverTextColor?: string;
	textAlign?: string;
	stretchButtonWidth?: boolean;
	endAdornmentSpaceBetween?: boolean;
	buttonHeight?: string;
	closeSubMenuOnClick?: boolean;
	className?: string;
	onSelectedItem?: (subMenuItem: DropdownButtonSubMenuItem) => void;
	textTransform?: string;
	padding?: string;
}

export default function DropdownButton(props: DropdownButtonPropsInterface) {
	const [showSubMenu, setShowSubMenu] = useState(false);
	return (
		<div
			className={`${props.stretchButtonWidth && "w-full"} ${
				props.className ?? ""
			}`}
			onMouseLeave={() => setShowSubMenu(false)}
		>
			<div
				className={`${props.stretchButtonWidth ? "w-auto" : "w-fit"} ${
					props.className ?? ""
				}`}
			>
				<Button
					className="min-h-full flex text-[12px]"
					height={props.buttonHeight}
					minWidth={props.minWidth}
					text={props.text}
					textColor={props.textColor}
					transparent={props.transparent}
					startAdornment={props.startAdornment}
					border={props.border}
					href={props.href}
					bgColor={props.bgColor}
					onHover={() => {
						setShowSubMenu(true);
					}}
					// onClick={(e) => {
					//   e.preventDefault();
					// }}
					endAdornmentSpaceBetween={props.endAdornmentSpaceBetween}
					endAdornment={
						<div
							className={`w-3 h-3 hidden ${showSubMenu && "rotate-180"} ${
								props.textColor && props.textColor
							} ${showSubMenu && props.hoverTextColor}`}
						>
							<IconArrowDown/>
						</div>
					}
					textTransform={props.textTransform}
					padding={props.padding ?? ""}
				>
					{showSubMenu ? (
						<div
							className={`flex z-10 flex-col absolute top-full ${
								props.border
									? "left-[-0.5px] min-w-[calc(100%+1px)]"
									: " min-w-full"
							} items-start`}
						>
							{props.customSubMenu
								? props.customSubMenu
								: props.subMenuItems.map((menuItem) => {
									return (
										<Button
											className="py-[10px]"
											key={menuItem.name}
											text={menuItem.name}
											onClick={(e) => {
												if (props.closeSubMenuOnClick) setShowSubMenu(false);
												if (menuItem.onClick) menuItem.onClick(e);
												props.onSelectedItem?.(menuItem);
											}}
											transparent={false}
											border={props.border}
											textAlign={props.textAlign}
											bgColor={props.bgColor ?? "bg-white"}
											hoverBgColor={props.hoverBgColor ?? "hover:bg-white"}
											href={menuItem.href}
											isDropdownSubmenuButton={true}
											textColor={`text-leo-brown`}
											hoverTextColor={`hover:text-leo-blue`}
										/>
									);
								})}
						</div>
					) : (
						<></>
					)}
				</Button>
			</div>
		</div>
	);
}
